<template>
  <div class="terms-page">
    <iframe :src="termsUrl" class="terms-frame"></iframe>
  </div>
</template>

<script>
export default {
  name: "TermsPage",
  computed: {
    termsUrl() {
      return "https://zakarpattya-api.billing.city/terms-service.html";
    },
  },
};
</script>

<style scoped>
.terms-page {
  background-color: #ffffff;
  min-height: 100%;
}

.terms-frame {
  position: fixed;
  width: 100%;
  height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  background-color: #ffffff;
}
</style>
